<div class="flex flex-col items-center gap-6 mt-6">
  <p-card class="w-full max-w-xl">
    <ng-template pTemplate="header">
      <h3 class="text-l font-semibold m-0 text-navy">Delete Account</h3>
    </ng-template>

    @if (!confirmState()) {
    <form [formGroup]="form" (ngSubmit)="onCheckCustomer()">
      <div class="mb-4">
        <label for="sourceCustomerID" class="block font-semibold mb-2">Customer ID to Remove</label>
        <input pInputText id="sourceCustomerID" type="text" formControlName="sourceCustomerID" placeholder="Customer ID"
          class="w-full" required>
      </div>
      <div class="flex gap-2">
        <p-button label="Perform Removal" type="submit" styleClass="btn btn-warning"
          [disabled]="form.invalid || isLoading()"></p-button>
      </div>
    </form>
    }

    @if (confirmState() && trips().length > 0) {
    <div class="alert alert-warning mb-4">
      <h4>Notice</h4>
      <p><strong>Please unassign any trips from this account before deleting it</strong></p>
      <p>Number of trips to unassign: {{trips().length}}</p>
      <p-button label="Take me there..." styleClass="btn btn-info" (onClick)="navigateToCustomerDetails()"></p-button>
    </div>
    }

    @if (confirmState() && trips().length === 0 && customer()) {
    <div class="mb-4">
      <strong>{{customer()?.groupname}} (group {{customerId()}})</strong> will be deleted from Mission Control.
    </div>
    <div class="flex gap-4">
      <button pButton type="button" label="Confirm Removal" class="btn btn-danger" (click)="onDeleteCustomer()"
        [disabled]="isApproving()"></button>
      <button pButton type="button" label="Cancel" class="btn" (click)="onCancel()"></button>
    </div>
    <p class="text-sm text-gray-500 mt-2 text-right">This cannot be undone...</p>
    }
    @if (isLoading()) {
    <div class="flex justify-center items-center mt-4"><span>Loading...</span></div>
    }
    @if (hasSearched() && confirmState() && !customer()) {
    <div class="flex justify-center items-center mt-4"><span>Customer not found.</span></div>
    }
    @if (errorMessage()) {
    <div class="alert alert-danger mt-4">{{errorMessage()}}</div>
    }
  </p-card>

</div>